import { render, staticRenderFns } from "./EventLogTable.vue?vue&type=template&id=24faf0ee&"
import script from "./EventLogTable.vue?vue&type=script&lang=js&"
export * from "./EventLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports